import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "./style.scss";

export type TabOptionType = {
  label: string;
  value: string;
  disabled?: boolean;
};

export type CustomTabSwitchProps = {
  tabOptionsList: TabOptionType[];
  onTabClick: (selectedValue: string) => void;
  preSelectedValue: string;
  parentClass?: string;
  heightClass?: string;
  maxWidthClass?: string; // use max width instead of width
};

export default function CustomTabSwitch(props: CustomTabSwitchProps) {
  const {
    tabOptionsList,
    onTabClick,
    preSelectedValue,
    parentClass = "",
    heightClass = "h-[40px]",
    maxWidthClass = "",
  } = props;
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onTabClick(newValue);
  };
  return (
    <Box
      className={`custom-tab-switch-container rounded-[8px] bg-[#F3F3F3] flex ${
        heightClass || ""
      } ${maxWidthClass || ""} ${parentClass || ""}`}
    >
      <Tabs
        value={preSelectedValue}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs"
      >
        {tabOptionsList.map((optionData: TabOptionType) => {
          return (
            <Tab
              label={optionData.label}
              value={optionData.value}
              className={`text-[14px] capitalize`}
              disabled={optionData.disabled}
            />
          );
        })}
      </Tabs>
    </Box>
  );
}
